<template>
  <div class="from_box flex">
    <!-- 新增弹窗 -->
    <el-dialog
      width="90%"
      height="80%"
      customClass="dialog_detail_style"
      title="选择销售订单号"
      :visible.sync="dialogSelectMatters"
      @close="cancelSelect"
      v-dialogDrag
    >
      <prodorder-input-list
        class="contnet_box"
        ref="selectMatter"
        :selectedList="selectedMatterSaleList"
        @selectSdata="selectSdata"
      ></prodorder-input-list>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSelect">取 消</el-button>
        <el-button type="primary" @click="selectMattersOk">确 定</el-button>
      </div>
    </el-dialog>
    <div class="item">
      <span class="txt">销售订单：</span>
      <!-- <el-input v-model="saleId" clearable placeholder="请输入销售订单号" @keyup.enter.native="enterGetSaleData($event)"></el-input> -->
      <el-input
        v-model="fromData.saleId"
        placeholder="点击右侧搜索"
        @change="prodOrderNoChange"
        :disabled="true"
        id="txt_saleVoucherNo"
        class="input-with-select"
      >
        <el-button slot="append" @click="enterGetSaleData1()" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="item">
      <span class="txt">公司：</span>
      <el-input v-model="fromData.companyDesc" placeholder="暂无公司" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">客户：</span>
      <el-input v-model="fromData.customerDesc" placeholder="暂无客户" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">订单状态：</span>
      <el-input v-model="fromData.refRoucherStatus" placeholder="暂无状态" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">凭证日期：</span>
      <el-date-picker v-model="fromData.voucherDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">过账日期：</span>
      <el-date-picker v-model="fromData.postingDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">抬头文本：</span>
      <el-input v-model="fromData.voucherHeaderTxt" placeholder="暂无抬头文本" :disabled="true"></el-input>
    </div>
  </div>
</template>

<script>
import { CancelOrder } from "api/business.js";
import prodorderInputList from "views/business/sale/SaleOrderListSelect.vue?typeId=0";

export default {
  components: {
    prodorderInputList
  },
  props: {
    fromData: Object,
    salesId: Number,
    selectedMatterSaleList: Array
  },
  data() {
    return {
      //已选的销售订单号
      customerListRes: {},
      dialogSelectMatters: false
    };
  },
  created() {
    //凭证和过账默认今天
    let nowData = new Date();
    this.$set(this.fromData, "voucherDate", nowData);
    this.$set(this.fromData, "postingDate", nowData);
  },
  computed: {},
  watch: {},
  methods: {
    //CancelOrder.Cancelout,{"saleVoucherNo":this.saleI
    async enterGetSaleData(saleId) {
      let res = await this.$post(CancelOrder.Cancelout, {
        saleVoucherNo: saleId
      });
      if (res == null || res.data == null || res.msgCode == "400") {
        this.$alert("销售订单 " + this.fromData.saleId + " 不存在");
        this.fromData.saleId = "";
      } else {
        res.data.details[0].lsmeng =
          res.data.details[0].targetNum - res.data.details[0].kbmeng;
        this.$store.state.cache.selectedMatterSaleCancel = res.data.details;
        this.$set(this.fromData, "voucherHeaderTxt", res.data.voucherHeaderTxt);
        if (res.data.maintainStatus == "N" || res.data.maintainStatus == null) {
          this.$set(this.fromData, "refRoucherStatus", "01-正常订单");
        } else if (res.data.maintainStatus == "X") {
          this.$set(this.fromData, "refRoucherStatus", "02-已删除订单");
        } else {
          this.$set(this.fromData, "refRoucherStatus", "03-冻结订单");
        }
        this.$set(this.fromData, "customerCode", res.data.customerCode);
        this.$set(this.fromData, "customerId", res.data.customerId);
        this.$set(this.fromData, "customerDesc", res.data.customerDesc);
        this.$set(this.fromData, "companyCode", res.data.companyCode);
        this.$set(this.fromData, "companyId", res.data.companyId);
        this.$set(this.fromData, "companyDesc", res.data.companyDesc);
        this.$set(this.fromData, "salesId", res.data.salesId);
      }
    },
    prodOrderNoChange(val) {
      //订单号改变时触发
      console.log(val);
    }, //输入订单号触发
    async enterGetSaleData1() {
      this.dialogSelectMatters = true;
    },
    selectSdata(res) {
      //获取所选
      console.log(res);
      this.selectList = res;
      //  this.sexList=res;
    },
    cancelSelect() {
      //取消所选v
      // this.$refs.selectMatter.cancelSelect();
      this.dialogSelectMatters = false;
    }, //新增弹窗确定所选
    async selectMattersOk() {
      //$('#txt_saleVoucherNo').val(this.selectList.saleVoucherNo);
      this.fromData.saleId = this.selectList.saleVoucherNo;
      this.dialogSelectMatters = false;
      this.enterGetSaleData(this.selectList.saleVoucherNo);
      //this.getFstock(this.selectList.planFactoryId);
    }
  }
};
</script>

<style>
</style>
